"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILURE = exports.SUCCESS = exports.START = exports.SAGA = void 0;
var SAGA = 'apiFlow/auth/SAGA';
exports.SAGA = SAGA;
var START = 'apiFlow/auth/START';
exports.START = START;
var SUCCESS = 'apiFlow/auth/SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'apiFlow/auth/FAILURE';
exports.FAILURE = FAILURE;